// @flow

import { combineReducers } from 'redux';

import travelCompanions from 'Components/widgets/profile-info/travel-companions/travelCompanions.reducer';
import { childcareLayerReducer } from 'Components/widgets/childcare-layer/ChildcareLayer.reducer';
import { bookingCartReducer } from 'Components/widgets/cart/bookingCart.reducer';
import bookingReducer from './booking/booking.reducer';
import prePaymentReducer from './pre-payment/prePayment.reducer';
import customer from './customer/customer.reducer';
import userSearches from './user-searches/userSearches.reducer';
import futureTrips from './future-trips/futureTrips.reducer';
import pastTrips from './past-trips/pastTrips.reducer';
import { quickLogin } from './quick-login/quickLogin.reducer';

export const memberSpace = combineReducers({
  booking: bookingReducer,
  prePayment: prePaymentReducer,
  customer,
  userSearches,
  futureTrips,
  pastTrips,
  travelCompanions,
  quickLogin,
  bookingChildcare: childcareLayerReducer,
  bookingCart: bookingCartReducer,
});
